<template>
  <section v-if="show" id="prayer-bar" class="content-bar d-flex bg-black justify-content-center">
    <ncc-content-column :html="prayer"/>
  </section>
</template>

<script>
    import NccContentColumn from "./NccContentColumn";

    export default {
        name: "NccQuestionPrayerBar",
        components: {NccContentColumn},
        computed: {
            show() {
                return this.$store.getters['showPrayer'] && this.prayer;
            },
            prayer() {
                const isModeForChildren = this.$store.getters['isModeForChildren'];
                const selectedQuestion = this.$store.getters['selectedQuestion'];

                if(!selectedQuestion) {
                    return null
                }

                if(isModeForChildren) {
                    return selectedQuestion['prayerChildren']
                }

                return selectedQuestion['prayerAdults']
            }
        }
    }
</script>

<style lang="scss" scoped>
  @media all and (min-width: 769px) {
    .video-bar {
      padding: 2.5rem 0;
    }
  }
</style>
